"use client"

import { useState, useEffect } from 'react';
import Image from "next/image";

import styles from "@/styles/modules/components/backtotop.module.scss";

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > window.outerHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scrolling behavior
    });
  };

  return (
    <div className={`${styles.backToTop} ${isVisible ? styles.isVisible : ''}`} onClick={scrollToTop}>
      <div className="backToTopIn">
        <Image
          alt="Arrow Back to top"
          src="/icons/arrow-back-to-top.svg"
          width={26}
          height={15}
        />
      </div>
    </div>
  );
}
